import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import Seo from "@/components/Seo";
import { api } from "@/lib/api";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const email = params.get("email") || "";
  const token = params.get("token") || "";
  const [state, setState] = useState(email && token ? "working" : "invalid");
  const [error, setError] = useState("");

  useEffect(() => {
    if (state !== "working") return;
    api.post("/unsubscribe", { email, token })
      .then(() => setState("done"))
      .catch((err) => { setError(err?.response?.data?.detail || "Something went wrong."); setState("failed"); });
  }, [state, email, token]);

  return (
    <section className="container-kore py-24 md:py-32 max-w-2xl min-h-[60vh]" data-testid="unsubscribe-page">
      <Seo title="Unsubscribe" description="Unsubscribe from KORE Wellbeing emails." path="/unsubscribe" noindex />
      <span className="eyebrow">Email preferences</span>
      {state === "working" && (
        <p className="mt-6 flex items-center gap-2 text-kore-ink/70" data-testid="unsubscribe-working"><Loader2 size={16} className="animate-spin" /> Updating your preferences…</p>
      )}
      {state === "done" && (
        <div data-testid="unsubscribe-done">
          <h1 className="display-1 mt-4 text-kore-forest">You're unsubscribed.</h1>
          <p className="mt-6 text-kore-ink/75 leading-relaxed">We've removed <strong>{email}</strong> from our mailing list. You won't receive any more tips or offers from KORE. If you've made an enquiry or booking, we'll still reply to that directly.</p>
          <p className="mt-4 text-sm text-kore-ink/60">Changed your mind? Just email <a className="underline" href="mailto:info@korewellbeing.com">info@korewellbeing.com</a>.</p>
        </div>
      )}
      {(state === "failed" || state === "invalid") && (
        <div data-testid="unsubscribe-error">
          <h1 className="display-1 mt-4 text-kore-forest">That link didn't work.</h1>
          <p className="mt-6 text-kore-ink/75 leading-relaxed">{error || "This unsubscribe link is missing or invalid."} To unsubscribe manually, email <a className="underline" href="mailto:info@korewellbeing.com">info@korewellbeing.com</a> and we'll sort it straight away.</p>
        </div>
      )}
      <p className="mt-10 text-sm"><Link to="/" className="underline text-kore-forest">Back to the homepage</Link></p>
    </section>
  );
}
